import React from "react";
import "./index.css";
import { HashRouter as Router, Outlet, Route, Routes } from "react-router-dom";
import Menu from "./components/Menu";
import { menus } from "./models/menu.model";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./lib/theme";
import TopHeader from "./components/TopHeader";
import CommonDialog from "./components/CommonDialog";
import SnackMessage from "./components/SnackMessage";
import PreviewMediaDialog from "./components/PreviewMediaDialog";
import ConfirmDialog from "./components/ConfirmDialog";
import CommonDrawer from "./components/CommonDrawer";
import { logout } from "./actions/auth.action";
import Login from "./containers/Login";
import NoResult from "./components/NoResult";

import "./styles/common.css";
import AdminPage from "./pages/admin.page";
import RolePage from "./pages/role.page";
import CompanyPage from "./pages/company.page";
import CompanyStoresPage from "./pages/company.store.page";
import CompanyUsersPage from "./pages/company.user.page";
import CustomersPage from "./pages/customer.page";
import QuestionsPage from "./pages/question.page";
import SurveysPage from "./pages/survey.page";
import SurveyEventsPage from "./pages/survey.event.page";
import { Helmet } from "react-helmet";
import ReportTranslationPage from "./pages/report.translation.page";

import {
  Chart as ChartJS,
  CategoryScale,
  ArcElement,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  ArcElement,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

export default function App(props: { logged: boolean }) {
  const [loaded, setLoaded] = React.useState(props.logged);
  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <title>Alfa Admin</title>
      </Helmet>
      {loaded ? (
        <Router>
          <Routes>
            <Route
              element={
                <div className="flex-wrapper app-page">
                  <Menu menus={menus} />
                  <div className="flex-1 width-100p padding-big">
                    <TopHeader
                      signOut={() => {
                        logout();
                        setLoaded(false);
                      }}
                    />
                    <Outlet />
                  </div>
                </div>
              }
            >
              <Route path="/admins" element={<AdminPage />} />
              <Route path="/roles" element={<RolePage />} />
              <Route path="/company-list" element={<CompanyPage />} />
              <Route path="/company-stores" element={<CompanyStoresPage />} />
              <Route path="/company-users" element={<CompanyUsersPage />} />
              <Route path="/customers" element={<CustomersPage />} />
              <Route path="/survey-questions" element={<QuestionsPage />} />
              <Route path="/survey-list" element={<SurveysPage />} />
              <Route path="/survey-events" element={<SurveyEventsPage />} />
              <Route
                path={"/report-translation"}
                element={<ReportTranslationPage />}
              />
              <Route path="*" element={<NoResult title="Page Not Found" />} />
            </Route>
          </Routes>
        </Router>
      ) : (
        <Login onLogin={() => setLoaded(true)} />
      )}
      <CommonDialog />
      <CommonDrawer />
      <ConfirmDialog />
      <PreviewMediaDialog />
      <SnackMessage />
    </ThemeProvider>
  );
}
